import {PageOf} from "../../../processes/massive_actions/CensusCooler/data/models/PageOf";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {getBaseUrl} from "../../../processes/massive_actions/CensusCooler/data/controllers/CensusCoolerController";
import {JSONCensus} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensus";
import {CensusListInfiniteHookProps} from "../hooks/CensusCoolerHooks";

export const fetchCensusList = async (
    params: CensusListInfiniteHookProps,
): Promise<PageOf<JSONCensus>> => {

    const paramsToSend = {
        page: params.page ?? 0,
        size: params.size ?? 20,
        sort: "createdAt,desc",
        status: ['SUBMITTED', 'EXECUTED']
    }

    return RestDataLoader.fetchData({
        url: `${getBaseUrl()}${RestDataLoader.objToUrlParams(Object.keys(paramsToSend), paramsToSend)}`,
        params: {},
    });
};

